module.exports = __webpack_public_path__ + "img/Exit.e436a72b.svg";